import { useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Alert, Avatar, Box, Button, Checkbox, Container, FormControlLabel, IconButton, InputAdornment, Paper, TextField, Typography, useMediaQuery } from '@mui/material';
import LockOutlined from '@mui/icons-material/LockOutlined';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useAuth } from './AuthContext';
import loginBackground from '../assets/images/wallpaper_padel_2.jpg';
import mobileBackground from '../assets/images/wallpaper_padel_1.jpg';
import CopyrightFooter from '../components/CopyrightFooter';

const validation = Yup.object({
  username: Yup.string().trim().max(100, 'Máximo 100 caracteres').required('Ingresá tu usuario'),
  password: Yup.string().max(255, 'Máximo 255 caracteres').required('Ingresá tu contraseña'),
  recordar: Yup.bool(),
});
export default function LoginScreen() {
  const { login } = useAuth();
  const isMobile = useMediaQuery('(max-width:600px)');
  const [visible, setVisible] = useState(false);
  const [error, setError] = useState('');
  return <Box sx={{
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    bgcolor: '#123747',
    backgroundImage: `linear-gradient(rgba(5, 24, 34, 0.25), rgba(5, 24, 34, 0.4)), url(${isMobile ? mobileBackground : loginBackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  }}>
    <Box component="main" sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', py: 4 }}>
    <Container maxWidth="xs"><Paper variant="outlined" sx={{
      p: { xs: 3, sm: 4 },
      borderRadius: 3,
      bgcolor: 'rgba(255, 255, 255, 0.96)',
      boxShadow: '0 16px 48px rgba(0, 0, 0, 0.25)',
    }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
        <Avatar sx={{ bgcolor: 'primary.main', mb: 2 }}><LockOutlined /></Avatar>
        <Typography component="h1" variant="h5">Ingreso al sistema</Typography>
        <Typography color="text.secondary" sx={{ mt: 1 }}>Accedé con tu cuenta para continuar.</Typography>
      </Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Formik initialValues={{ username: '', password: '', recordar: false }} validationSchema={validation}
        onSubmit={async (values) => {
          setError('');
          try { await login({ ...values, username: values.username.trim() }); }
          catch (failure) { setError(failure.status ? failure.message : 'No se pudo conectar con el servidor. Intentá nuevamente.'); }
        }}>
        {({ values, touched, errors, handleChange, handleBlur, isSubmitting }) => <Form>
          <TextField fullWidth autoFocus name="username" label="Usuario" autoComplete="username" margin="normal"
            value={values.username} onChange={handleChange} onBlur={handleBlur} disabled={isSubmitting}
            error={Boolean(touched.username && errors.username)} helperText={touched.username && errors.username} />
          <TextField fullWidth name="password" label="Contraseña" autoComplete="current-password" margin="normal"
            type={visible ? 'text' : 'password'} value={values.password} onChange={handleChange} onBlur={handleBlur} disabled={isSubmitting}
            error={Boolean(touched.password && errors.password)} helperText={touched.password && errors.password}
            InputProps={{ endAdornment: <InputAdornment position="end"><IconButton type="button"
              aria-label={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'} onClick={() => setVisible(!visible)}
              onMouseDown={(event) => event.preventDefault()}>{visible ? <VisibilityOff /> : <Visibility />}</IconButton></InputAdornment> }} />
          <FormControlLabel label="Recordar" control={<Checkbox name="recordar" checked={values.recordar} onChange={handleChange} disabled={isSubmitting} />} />
          <Button fullWidth variant="contained" size="large" type="submit" disabled={isSubmitting} sx={{ mt: 2 }}>{isSubmitting ? 'Ingresando…' : 'Ingresar'}</Button>
        </Form>}
      </Formik>
    </Paper></Container>
    </Box>
    <CopyrightFooter />
  </Box>;
}
